export default class PluginMetric {
  filterGroups;

  metrics;

  selectedMetricId;

  isCustomQuery;

  query;

  queryType;

  ratioQuery;

  constructor(json) {
    this.fromJSON(json);
  }

  fromJSON(res = {}) {
    const filterGroups = [];
    if (res.filters) {
      Object.keys(res.filters).forEach((filterGroup) => {
        const filters = [];
        res.filters[filterGroup].forEach((json) => {
          const filter = new Filter();
          filter.fromJSON(json);
          filters.push(filter);
        });
        filterGroups.push({
          name: filterGroup,
          filters,
        });
      });
    }
    this.filterGroups = filterGroups;
    const metrics = [];
    if (res.metrics) {
      res.metrics.forEach((json) => {
        const metric = new Metric();
        metric.fromJSON(json);
        metrics.push(metric);
      });
    }
    this.metrics = metrics;
    this.selectedMetricId = res.selectedMetricId;
    this.isCustomQuery = res.isCustomQuery;
    this.query = res.query;
    this.queryType = res.queryType;
    this.ratioQuery = res.ratioQuery;
  }
}

class Filter {
  id;

  uiType;

  displayName;

  values;

  constructor(json) {
    this.fromJSON(json);
  }

  fromJSON(res = {}) {
    this.id = res.id;
    this.uiType = res.uiType;
    this.displayName = res.displayName;
    this.values = res.values;
  }
}

class Metric {
  id;

  name;

  isPredefined;

  isCustomQuery;

  filterGroup;

  query;

  baseMetricId;

  filters;

  queryType;

  ratioQuery;

  constructor(json) {
    this.fromJSON(json);
  }

  fromJSON(res = {}) {
    this.id = res.id;
    this.name = res.name;
    this.isPredefined = res.isPredefined;
    this.isCustomQuery = res.isCustomQuery;
    this.filterGroup = res.filterGroup;
    this.query = res.query;
    this.baseMetricId = res.baseMetricId;
    this.filters = res.filters;
    this.queryType = res.queryType;
    this.ratioQuery = res.ratioQuery;
  }
}
